import { call, put, fork } from "redux-saga/effects";

import { takeFetchRemoteData } from "../util";

function* buscaAtivosCarteiraSaga({ api }) {
  yield takeFetchRemoteData("buscaAtivos", function*(action) {
    const {
      meta: {
        resolve,
        reject,
        properties: { query },
      },
    } = action;

    try {
      const ativos = yield call(api.buscaAtivos, query);
      yield put(resolve(ativos.map(({ codigo: id, nome }) => ({ id, nome }))));
    } catch (error) {
      const mensagem =
        error.response && error.response.statusCode >= 500
          ? "Erro inesperado"
          : error.response && error.response.text
          ? yield error.response.text()
          : "Erro inesperado";
      yield put(reject(mensagem || "Erro inesperado"));
    }
  });
}

function* buscaAtivosSelecionadosSaga({ api }) {
  yield takeFetchRemoteData("buscaAtivosSelecionaveis", function*(action) {
    const {
      meta: {
        resolve,
        reject,
        properties: { query, filtroBusca },
      },
    } = action;

    try {
      const ativos = yield call(api.buscaAtivoSelecionavel, query, filtroBusca);
      yield put(
        resolve(
          ativos.map(
            ({
              itemSelecionavel: { identificador: id, tipoItemSelecionavel },
              label: nome,
              codigoGrupo,
              informacaoAdicional,
            }) => ({
              id,
              tipoItemSelecionavel,
              nome,
              codigoGrupo,
              informacaoAdicional,
            })
          )
        )
      );
    } catch (error) {
      const mensagem =
        error.response && error.response.statusCode >= 500
          ? "Erro inesperado"
          : error.response && error.response.text
          ? yield error.response.text()
          : "Erro inesperado";
      yield put(reject(mensagem || "Erro inesperado"));
    }
  });
}

function* buscaAtivosColecao({ api }) {
  yield takeFetchRemoteData("buscaAtivosColecao", function*(action) {
    const {
      meta: {
        resolve,
        reject,
        properties: { identificador, tipoItemSelecionavel },
      },
    } = action;

    try {
      const ativos = yield call(
        api.buscaAtivosColecao,
        identificador,
        tipoItemSelecionavel
      );
      yield put(
        resolve(
          ativos.map(
            ({ identificador: id, tipoItemSelecionavel, label: nome }) => ({
              id,
              tipoItemSelecionavel,
              nome,
            })
          )
        )
      );
    } catch (error) {
      const mensagem =
        error.response && error.response.statusCode >= 500
          ? "Erro inesperado"
          : error.response && error.response.text
          ? yield error.response.text()
          : "Erro inesperado";
      yield put(reject(mensagem || "Erro inesperado"));
    }
  });
}

function* buscaInformacoesAdicionaisAtivos({ api }) {
  yield takeFetchRemoteData("buscaInformacoesAdicionaisAtivos", function*(
    action
  ) {
    const {
      meta: {
        resolve,
        reject,
        properties: { ativos },
      },
    } = action;

    try {
      const resultado = yield call(
        api.buscaInformacoesAdicionaisAtivos,
        ativos
      );
      yield put(
        resolve(
          resultado.map(
            ({
              itemSelecionavel: { identificador: id, tipoItemSelecionavel },
              label: nome,
              codigoGrupo,
              informacaoAdicional,
            }) => ({
              id,
              tipoItemSelecionavel,
              nome,
              codigoGrupo,
              informacaoAdicional,
            })
          )
        )
      );
    } catch (error) {
      const mensagem =
        error.response && error.response.statusCode >= 500
          ? "Erro inesperado"
          : error.response && error.response.text
          ? yield error.response.text()
          : "Erro inesperado";
      yield put(reject(mensagem || "Erro inesperado"));
    }
  });
}

export default function* buscaAtivosSaga({ api }) {
  yield fork(buscaAtivosCarteiraSaga, { api });
  yield fork(buscaAtivosSelecionadosSaga, { api });
  yield fork(buscaAtivosColecao, { api });
  yield fork(buscaInformacoesAdicionaisAtivos, { api });
}
